// extracted by mini-css-extract-plugin
export default {"container":"StaticMapImage_container__eVkEf","img_container":"StaticMapImage_img_container__gjkai"};